module.exports = __webpack_public_path__ + "images/花筑院子全景_04-3.jpg?v=beea7e09";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu4/花筑院子全景_04-3.jpg
 ** module id = 74
 ** module chunks = 1 2
 **/